import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { ad1 } from "../../constants";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/view-banner-ad.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const View_Banner_Ad = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* View banner ads starts here */}
							<div className="banner-ads">
								<div className="view-banner-ads-heading-wrapper">
									<h2>View Banner Ads</h2>
									<h4>( 03 )</h4>
								</div>
								<div className="view-card-wrapper">
									<div className="ads-content-wrapper">
										<div className="ads-date-list-wrapper">
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Start Date</h5>
													<h6>12 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>End Date</h5>
													<h6>22 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Banner Price</h5>
													<h6>$ 40.00</h6>
												</div>
											</div>
										</div>
										<div className="ads-brand-link-wrapper">
											<label htmlFor="">Your Brand Link </label>
											<div className="fields-wrapper">
												<input
													type="text"
													placeholder="Lorem ipsum dolor sit amet, consectetur "
													className="form-control"
												/>
												<button className="btn"> Copy Link</button>
											</div>
										</div>
									</div>
									<div className="ads-img-wrapper">
										<div className="ad-img">
											<figure>
												<img src={ad1} className="img-fluid" alt="" />
											</figure>
											<div className="btn-wrapper d-flex justify-content-between w-100 align-items-center px-3">
												<a href="/edit-ad-form" className="edit-btn">
													Edit Ads
												</a>
												<button className="delete">
													<i className="fa fa-trash"></i>
												</button>
											</div>
										</div>
										<div className="expire-date-wrapper">
											<h6>Expire Date :</h6>
											<h6>10 Nov 2022</h6>
										</div>
									</div>
								</div>
								<div className="view-card-wrapper">
									<div className="ads-content-wrapper">
										<div className="ads-date-list-wrapper">
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Start Date</h5>
													<h6>12 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>End Date</h5>
													<h6>22 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Banner Price</h5>
													<h6>$ 40.00</h6>
												</div>
											</div>
										</div>
										<div className="ads-brand-link-wrapper">
											<label htmlFor="">Your Brand Link </label>
											<div className="fields-wrapper">
												<input
													type="text"
													placeholder="Lorem ipsum dolor sit amet, consectetur "
													className="form-control"
												/>
												<button className="btn"> Copy Link</button>
											</div>
										</div>
									</div>
									<div className="ads-img-wrapper">
										<div className="ad-img">
											<figure>
												<img src={ad1} className="img-fluid" alt="" />
											</figure>
											<div className="btn-wrapper d-flex justify-content-between w-100 align-items-center px-3">
												<a href="/edit-ad-form" className="edit-btn">
													Edit Ads
												</a>
												<button className="delete">
													<i className="fa fa-trash"></i>
												</button>
											</div>
										</div>
										<div className="expire-date-wrapper">
											<h6>Expire Date :</h6>
											<h6>10 Nov 2022</h6>
										</div>
									</div>
								</div>
								<div className="view-card-wrapper">
									<div className="ads-content-wrapper">
										<div className="ads-date-list-wrapper">
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Start Date</h5>
													<h6>12 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>End Date</h5>
													<h6>22 _ Nov _2022</h6>
												</div>
											</div>
											<div className="single-date-wrapper">
												<div className="date">
													<h5>Banner Price</h5>
													<h6>$ 40.00</h6>
												</div>
											</div>
										</div>
										<div className="ads-brand-link-wrapper">
											<label htmlFor="">Your Brand Link </label>
											<div className="fields-wrapper">
												<input
													type="text"
													placeholder="Lorem ipsum dolor sit amet, consectetur "
													className="form-control"
												/>
												<button className="btn"> Copy Link</button>
											</div>
										</div>
									</div>
									<div className="ads-img-wrapper">
										<div className="ad-img">
											<figure>
												<img src={ad1} className="img-fluid" alt="" />
											</figure>
											<div className="btn-wrapper d-flex justify-content-between w-100 align-items-center px-3">
												<a href="/edit-ad-form" className="edit-btn">
													Edit Ads
												</a>
												<button className="delete">
													<i className="fa fa-trash"></i>
												</button>
											</div>
										</div>
										<div className="expire-date-wrapper">
											<h6>Expire Date :</h6>
											<h6>10 Nov 2022</h6>
										</div>
									</div>
								</div>
								<div className="upload-btn-wrapper">
									<a href="/banner-ad-form" className="btn">
										Upload New Banner
									</a>
								</div>
							</div>
							{/* View banner ads ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default View_Banner_Ad;
